var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSortingVisualizer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 400,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg3",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#0f2027",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    style: {
      stopColor: "#203a43",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#2c5364",
      stopOpacity: 1
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 400,
    fill: "url(#bg3)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(40, 40)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 520,
    height: 320,
    rx: 10,
    fill: "#ffffff",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("text", {
    x: 260,
    y: 40,
    textAnchor: "middle",
    fontFamily: "Arial, sans-serif",
    fontSize: 20,
    fontWeight: "bold",
    fill: "#0f2027"
  }, "Sorting Visualizer"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(40, 80)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 120,
    width: 20,
    height: 60,
    fill: "#e63946"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 100,
    width: 20,
    height: 80,
    fill: "#f1fa8c"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 60,
    width: 20,
    height: 120,
    fill: "#a8dadc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 20,
    width: 20,
    height: 160,
    fill: "#457b9d"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 80,
    width: 20,
    height: 100,
    fill: "#1d3557"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 40,
    width: 20,
    height: 140,
    fill: "#06d6a0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 100,
    width: 20,
    height: 80,
    fill: "#ffd166"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 140,
    width: 20,
    height: 40,
    fill: "#ef476f"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "0,120 45,95 75,70 100,60 135,85 160,70 190,95 220,140",
    fill: "none",
    stroke: "#2c5364",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(40, 260)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 120,
    height: 36,
    rx: 6,
    fill: "#2c5364"
  }), /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 24,
    textAnchor: "middle",
    fontFamily: "Arial",
    fontSize: 14,
    fill: "#fff"
  }, "Start Sorting"), /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 0,
    width: 120,
    height: 36,
    rx: 6,
    fill: "#457b9d"
  }), /*#__PURE__*/React.createElement("text", {
    x: 210,
    y: 24,
    textAnchor: "middle",
    fontFamily: "Arial",
    fontSize: 14,
    fill: "#fff"
  }, "Shuffle")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortingVisualizer);
export default __webpack_public_path__ + "static/media/sorting-visualizer.6641e2463f73f5d8874ce293bbb5c37e.svg";
export { ForwardRef as ReactComponent };